module.exports = __webpack_public_path__ + "img/placeholder.57c29242.png";